import { Dispatch, useState } from "react"
import { LocalStorage } from "../constants/local-storage"

const isLocalStorageAvailable = () => {
  try {
    return typeof window !== "undefined" && Boolean(localStorage)
  } catch (e) {
    return false
  }
}
const useStateWithLocalStorage = <T = string>(
  localStorageKey: LocalStorage
): [T | null, Dispatch<T>] => {
  const key = `mudita-` + localStorageKey
  const [value, setValue] = useState(() =>
    isLocalStorageAvailable() ? (localStorage.getItem(key) as any as T) : null
  )

  const storeValue = (newValue: T) => {
    if (isLocalStorageAvailable()) {
      localStorage.setItem(key, (newValue as any).toString())
    }
    setValue(newValue)
  }

  return [value, storeValue]
}

export const clearLocalStorage = (localStorageKey: LocalStorage) => {
  const key = `mudita-` + localStorageKey
  if (isLocalStorageAvailable()) {
    localStorage.removeItem(key)
  }
}

export const getFromLocalStorage = (localStorageKey: LocalStorage) => {
  const key = `mudita-` + localStorageKey
  return isLocalStorageAvailable() ? localStorage.getItem(key) : null
}

export const setInLocalStorage =
  (localStorageKey: LocalStorage) => (newValue: string) => {
    const key = `mudita-` + localStorageKey
    if (isLocalStorageAvailable()) {
      localStorage.setItem(key, newValue)
    }
  }

export default useStateWithLocalStorage
